export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";

export const SPR_TASK_ID = "sprTaskId";
export const SPR_RECORD_ID = "sprRecordId";

export const QAS_DOC_ID = "qasDocId";
export const QAS_QUESTION_ID = "qasQuestionId";
export const QAS_TEMPLATE_ID = "qasTemplateId";
export const QAS_MESSAGE_HISTORY_DEPTH = "qasMessageHistoryDepth";
export const QAS_PROMPT_TEMPLATE = "qasPromptTemplate";

export const QAS_FILTER_CATEGORY = "qasFilterCategory";
export const QAS_FILTER_QUESTION = "qasFilterQuestion";
export const QAS_FILTER_ANSWER = "qasFilterAnswer";
export const QAS_FILTER_ANSWER_TYPE = "qasFilterAnswerType";
export const QAS_FILTER_COMPLETENESS = "qasFilterCompleteness";
export const QAS_FILTER_START_DATE = "qasFilterStartDate";
export const QAS_FILTER_END_DATE = "qasFilterEndDate";

export const AUTOSAVE_QUESTION = "autosaveQuestion";
export const AUTOSAVE_TRANSCRIPT = "autosaveTranscript";
export const BACKGROUND_IMAGE = "backgroundImage";
export const COLORING_CONFIDENCE = "coloringConfidence";
export const COLORING_CONFIDENCE_THRESHOLD = "coloringConfidenceThreshold";
export const CLOUD_DATA_PRESENTATION = "cloudDataPresentation";

export const ROLE_ID = "roleId";

export const SPEAKER_ID = "speakerId";

export const ROBOT_ID = "robotId";
export const LIST_OF_UNCOMMITTED_ROBOTS = "listOfUncommittedRobots";

export const MARK_ID = "markId";
export const AUTO_MARK_TASK_ID = "autoMarkTaskId";

export const DASHBOARD_NAME = "dashboardName";
